import {
  KycIntegrationMethodOwner,
  OwnedKycIntegrationMethod,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const CompletedKyc = (props: { kycIntegrationMethod: OwnedKycIntegrationMethod }) => {
  const { palette } = useCustomTheme();

  return (
    <CustomPaper fill="success.light" style={{ padding: 16 }}>
      <FlexRow gridGap={4} justifyContent={'flex-start'}>
        <Icon size={24} color={palette.success.main}>
          check
        </Icon>
        <Text tId="KYC_COMPLETED_VERIFICATION_TEXT" strong /> (
        <Text
          tId={
            props.kycIntegrationMethod.owner === KycIntegrationMethodOwner.BORROWER ? 'KYC_TITULAR' : 'KYC_COTITULAR'
          }
        />
        )
      </FlexRow>
    </CustomPaper>
  );
};
